<div
  [formGroup]="flightFormGroup"
  class="row multicity-flight-item multicity-header-align"
  ngc-error-handler-helper
>
  <div class="p-sm-0 col-12">
    <span
      [attr.id]="'flightLabel' + (index + 1)"
      class="multicity-flight-label"
    >
      {{ 'Flight ' + (index + 1) }}
    </span>
  </div>
  <div
    [attr.aria-describedby]="'flightLabel' + (index + 1)"
    class="p-sm-0 col-12"
  >
    <div class="row flight-content-row multicity-header-align">
      <div
        class="p-sm-0 col-lg-4 col-md-12 col-sm-12 offset-lg-0 text-center multicity-mt-top-airport"
        formGroupName="airports"
      >
        <div class="row no-gutters multicity-flight-from-to">
          <a
            #deptAirportLookupDir="ngcAirportLookupDirective"
            #fromAirportElement
            (click)="deptAirportLookupDir?.openLookupModal(true)"
            (keydown)="
              $event.keyCode !== 13 &&
              (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                ($event.keyCode >= 48 && $event.keyCode <= 57))
                ? deptAirportLookupDir?.openLookupModal(0)
                : ''
            "
            (searchedAirportCode)="fromAirportcode = $event; fromCity = ''"
            (selectedAirport)="
              fromAirportcode = $event.airportCode;
              fromCountryCode = $event.countryCode;
              resetToAirport();
              fromCity = $event.city + ', ' + $event.region
            "
            [attr.id]="'fromAirportLink' + (index + 1)"
            [initialLookupKey]="fromAirportcode"
            [lookupTitle]="'Origin'"
            aria-haspopup="true"
            class="from-container no-underline col-lg-5 col-5 order-1 text-left"
            href="javascript:void(0);"
            ngc-airport-lookup-directive
          >
            <span class="sr-only">{{ 'Flight ' + (index + 1) }}</span>
            <span
              [innerHTML]="
                fromAirportcode && fromAirportcode !== ''
                  ? fromAirportcode
                  : fromAirportLabel
              "
              [ngClass]="{
                'airport-code-placeholder':
                  !fromAirportcode || fromAirportcode === ''
              }"
              class="airport-code d-block"
            ></span>
            <span class="sr-only">Deprature Airport Code</span>
            <span [innerHTML]="fromCity" class="airport-desc sr-only"></span>
            <input
              [(ngModel)]="fromAirportcode"
              [attr.id]="'fromAirportCode' + (index + 1)"
              [attr.name]="'fromAirportCode'"
              [formControlName]="'fromAirportcode'"
              type="hidden"
            />
            <input
              [(ngModel)]="fromCountryCode"
              [attr.id]="'fromCountryCode' + (index + 1)"
              [attr.name]="'fromCountryCode'"
              [formControlName]="'fromCountryCode'"
              type="hidden"
            />
            <input
              [(ngModel)]="fromCity"
              [attr.id]="'fromCity' + (index + 1)"
              [attr.name]="'fromCity'"
              [formControlName]="'fromCity'"
              type="hidden"
            />
          </a>
          <a
            #toAirportLookupDir="ngcAirportLookupDirective"
            (click)="toAirportLookupDir?.openLookupModal(true)"
            (keydown)="
              $event.keyCode !== 13 &&
              (($event.keyCode >= 65 && $event.keyCode <= 90) ||
                ($event.keyCode >= 96 && $event.keyCode <= 105) ||
                ($event.keyCode >= 48 && $event.keyCode <= 57))
                ? toAirportLookupDir?.openLookupModal(0)
                : ''
            "
            (searchedAirportCode)="
              toAirportcode = $event; toCity = ''; destAirportSelected($event)
            "
            (selectedAirport)="
              toAirportcode = $event.airportCode;
              toCountryCode = $event.countryCode;
              mpmRestriction = $event.restrictMPM;
              milesRestriction = $event.restrictMiles;
              toCity = $event.city + ', ' + $event.region;
              destAirportSelected($event)
            "
            [attr.id]="'toAirportLink' + (index + 1)"
            [initialLookupFromKey]="fromAirportcode"
            [initialLookupKey]="toAirportcode"
            [lookupTitle]="'Destination'"
            [tripType]="'MULTICITY'"
            aria-haspopup="true"
            class="to-container no-underline col-lg-5 col-5 order-3 text-right"
            href="javascript:void(0);"
            ngc-airport-lookup-directive
          >
            <span class="sr-only">{{ 'Flight ' + (index + 1) }}</span>
            <span
              [innerHTML]="
                toAirportcode && toAirportcode !== ''
                  ? toAirportcode
                  : toAirportLabel
              "
              [ngClass]="{
                'airport-code-placeholder':
                  !toAirportcode || toAirportcode === ''
              }"
              class="airport-code d-block"
            ></span>
            <span class="sr-only">Arrival Airport Code</span>
            <span [innerHTML]="toCity" class="airport-desc sr-only"></span>
            <input
              [(ngModel)]="toAirportcode"
              [attr.id]="'toAirportcode' + (index + 1)"
              [attr.name]="'toAirportcode'"
              [formControlName]="'toAirportcode'"
              type="hidden"
            />
            <input
              [(ngModel)]="toCountryCode"
              [attr.id]="'toCountryCode' + (index + 1)"
              [attr.name]="'toCountryCode'"
              [formControlName]="'toCountryCode'"
              type="hidden"
            />
            <input
              [(ngModel)]="toCity"
              [attr.id]="'toCity' + (index + 1)"
              [attr.name]="'toCity'"
              [formControlName]="'toCity'"
              type="hidden"
            />
            <input
              [(ngModel)]="mpmRestriction"
              [attr.id]="'mpmRestriction' + (index + 1)"
              [attr.name]="'mpmRestriction'"
              [formControlName]="'mpmRestriction'"
              type="hidden"
            />
            <input
              [(ngModel)]="milesRestriction"
              [attr.id]="'milesRestriction' + (index + 1)"
              [attr.name]="'milesRestriction'"
              [formControlName]="'milesRestriction'"
              type="hidden"
            />
          </a>
          <div class="swap-container col-2 col-lg-2 col-sm-2 order-2 p-0">
            <a
              (click)="swapCity()"
              c
              class="swapfield icon-swap d-inline-block"
              href="javascript:void(0);"
              role="button"
              title="Reverse origin and destination city or airport"
            ></a>
          </div>
        </div>
        <ngc-validation-error-message
          [control]="flightFormGroup?.controls.airports"
          [controlname]="'airports'"
          [focusedFieldId]="mcityairportFieldFocus(index + 1)"
          [makeVisible]="errorHandler?.makeVisible"
          [ngClass]="{ tofielderr: tofieldErr === true }"
          [showErrorOnChange]="false"
        ></ngc-validation-error-message>
      </div>

      <div
        class="p-sm-0 col-lg-2 col-md-12 col-12 offset-lg-1 multicity-mt-top-datepicker"
      >
        <label [attr.for]="'departureDate' + (index + 1)" class="sr-only">
          Departure Date
        </label>
        <date-selection-view
          (inputBlur)="inputBlur($event)"
          [checkJourneyType]="'oneway'"
          [dateFor]="'departureDate' + (index + 1)"
          [defaultDepartDate]="forHiddendepartureDate"
          [displayDateFormat]="'Mmm/dd'"
          [formObj]="flightFormGroup"
          [formObject]="flightFormGroup"
          [index]="index + 1"
          [travelType]="'Departure'"
          departPlaceHolderText="{{ bookContent?.multicityDepartLabel }}"
          departlabelText="{{ bookContent?.multicityDepartLabel }}"
          name="departureDate"
          returnPlaceHolderText="Return"
          returnlabelText="Return"
          standaloneCal="true"
        ></date-selection-view>

        <ngc-validation-error-message
          [control]="flightFormGroup?.controls.departureDate"
          [controlname]="'departureDate'"
          [focusedFieldId]="'input_departureDate_' + (index + 1)"
          [index]="index + 1"
          [makeVisible]="errorHandler?.makeVisible"
        ></ngc-validation-error-message>
      </div>

      <div class="p-sm-0 col-lg-4 col-md-6 col-12 offset-lg-1 mb-3">
        <a
          #connectionAirportLookupDir="ngcAirportLookupDirective"
          (click)="connectionAirportLookupDir?.openLookupModal(0)"
          (focusout)="markAsTouchedFrom()"
          (keydown)="
            $event.keyCode !== 13 &&
            (($event.keyCode >= 65 && $event.keyCode <= 90) ||
              ($event.keyCode >= 96 && $event.keyCode <= 105) ||
              ($event.keyCode >= 48 && $event.keyCode <= 57))
              ? connectionAirportLookupDir?.openLookupModal(0)
              : ''
          "
          (searchedAirportCode)="connection = $event"
          (selectedAirport)="connection = $event.airportCode"
          [attr.id]="'connection' + (index + 1)"
          [initialLookupKey]="connection"
          [lookupTitle]="'Connection'"
          [ngc-data-value]="connection"
          [ngc-floatinglabel]="bookContent?.connectionFloatingLabel"
          [ngc-isOptional]="true"
          [ngc-useDataValue]="true"
          aria-haspopup="true"
          class="multicity-connection-airport form-control mb-2 mb-sm-0 connect"
          href="javascript:void(0);"
          ngc-airport-lookup-directive
        >
          <input
            [(ngModel)]="connection"
            [attr.id]="'connection' + (index + 1)"
            [formControlName]="'connectionAirport'"
            name="connectionAirport"
            type="hidden"
          />
          <span class="sr-only">{{ 'Flight ' + (index + 1) }}</span>
          <span
            [ngClass]="{ 'connection-desc': !connection || connection === '' }"
          >
            {{ connection ? connection : bookContent?.connectionLabel }}
            {{ connection ? '' : '(Optional)' }}
          </span>
          <span class="sr-only">Airport Code</span>
        </a>
        <ngc-validation-error-message
          [control]="flightFormGroup?.controls.connectionAirport"
          [controlname]="'connectionAirport'"
          [focusedFieldId]="'connection' + (index + 1)"
          [makeVisible]="errorHandler?.makeVisible"
        ></ngc-validation-error-message>
        <a
          #connectionHelp="ngcHelpModalDirective"
          (click)="connectionHelp?.openHelpModal()"
          [helpContent]="bookContent?.tooltips?.get('flight-connection')"
          [type]="'connection'"
          aria-haspopup="true"
          class="connection-help icon-help circle-outline"
          href="javascript:void(0)"
          ngc-help-modal-directive
        >
          <span class="sr-only">{{ bookContent?.connectionLabel }} help</span>
        </a>
      </div>
    </div>
  </div>
  <input
    [attr.id]="'originCity__' + (index + 1)"
    [attr.name]="'originCity[' + (index + 1) + ']'"
    type="hidden"
    value="{{ fromAirportcode }}"
  />
  <input
    [attr.id]="'destinationCity__' + (index + 1)"
    [attr.name]="'destinationCity[' + (index + 1) + ']'"
    type="hidden"
    value="{{ toAirportcode }}"
  />
  <input
    [attr.id]="'departureDate__' + (index + 1)"
    [attr.name]="'departureDate[' + (index + 1) + ']'"
    type="hidden"
    value="{{ forHiddendepartureDate }}"
  />
  <input
    [attr.id]="'connectionCity__' + (index + 1)"
    [attr.name]="'connectionCity[' + (index + 1) + ']'"
    type="hidden"
    value="{{ connection }}"
  />
  <input
    [attr.id]="'departureTime__' + (index + 1)"
    [attr.name]="'departureTime[' + (index + 1) + ']'"
    type="hidden"
    value="AT"
  />
  <input
    [attr.id]="'mpmRestriction' + (index + 1)"
    [attr.name]="'mpmRestriction[' + (index + 1) + ']'"
    type="hidden"
    value="{{ mpmRestriction }}"
  />
  <input
    [attr.id]="'milesRestriction' + (index + 1)"
    [attr.name]="'milesRestriction[' + (index + 1) + ']'"
    type="hidden"
    value="{{ milesRestriction }}"
  />
</div>
